export const BASE_INTERNAL_URL = '__internal-admin__';
export const NEW_REPORT_APP_BASE = '/reports'; // * This is temporary, will switch back to '/reports' when new UIs are ready
export const ASSESSMENT_APP_BASE = '';
export const ASSESSMENT_APP_TEST_SESSION_BASE = '/session';
